enum ProductTypeDto {
    Casino = 'Casino',
    Sportsbook = 'Sportsbook',
    Virtuals = 'Virtuals',
    CasinoVirtuals = 'Casino Virtuals', // Golden Race virtuals
}

export default ProductTypeDto;
